(() => {
  const HISTORY_KEY = 'epFpdOpen';
  let hasConfiguratorHistory = Boolean(window.history.state?.[HISTORY_KEY]);

  const getAppTrigger = (root) => {
    if (!root) return null;
    return root.querySelector('button, [role="button"], a');
  };

  const getNativeAppTrigger = (source) => {
    const productInfo = source?.closest('.product__info-container') || document;
    const appBlock = productInfo.querySelector('.shopify-app-block');
    return getAppTrigger(appBlock);
  };

  const isVisible = (element) =>
    Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));

  const getVisibleConfiguratorClose = () => {
    const closeButtons = document.querySelectorAll(
      '.fpd-wrapper.fpd-container [data-pos="modal"] > .fpd-close:not(.fpd-done)'
    );
    return Array.from(closeButtons).find(isVisible) || null;
  };

  const openConfiguratorHistory = () => {
    if (hasConfiguratorHistory || window.history.state?.[HISTORY_KEY]) {
      hasConfiguratorHistory = true;
      return;
    }

    window.history.pushState(
      { ...window.history.state, [HISTORY_KEY]: true },
      '',
      window.location.href
    );
    hasConfiguratorHistory = true;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest('[data-ep-fpd-trigger], #fpd-customize-button');
    if (trigger) {
      openConfiguratorHistory();

      if (trigger.matches('[data-ep-fpd-trigger]')) {
        getNativeAppTrigger(trigger)?.click();
      }
      return;
    }

    const closeButton = target.closest(
      '.fpd-wrapper.fpd-container [data-pos="modal"] > .fpd-close'
    );
    if (!closeButton || !hasConfiguratorHistory || !window.history.state?.[HISTORY_KEY]) return;

    hasConfiguratorHistory = false;
    window.history.back();
  }, true);

  window.addEventListener('popstate', (event) => {
    if (event.state?.[HISTORY_KEY]) {
      hasConfiguratorHistory = true;
      const nativeTrigger = getNativeAppTrigger(document.documentElement);
      if (nativeTrigger && !getVisibleConfiguratorClose()) nativeTrigger.click();
      return;
    }

    if (!hasConfiguratorHistory) return;

    hasConfiguratorHistory = false;
    getVisibleConfiguratorClose()?.click();
  });
})();
